export const getButtonText = pathname => {
  if (pathname === '/admin') return { left: 'Chests', right: 'Secrets' };
  if (pathname.includes('/admin/chests')) return { left: 'Chests', right: 'Secrets' };
  if (pathname.includes('/admin/teams')) return { left: 'Teams', right: 'Users' };
  return { left: 'Left', right: 'Right' };
};
